"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdManager = exports.AdUnit = void 0;
const Global_1 = require("../Global");
const rxjs_1 = require("rxjs");
const admob_plus_cordova_1 = require("admob-plus-cordova");
const config_json_1 = __importDefault(require("../../../shared/config.json"));
const AssetManager_1 = __importDefault(require("./AssetManager"));
var AdUnit;
(function (AdUnit) {
    AdUnit[AdUnit["GameplayStart"] = 0] = "GameplayStart";
    AdUnit[AdUnit["BottomFrame"] = 1] = "BottomFrame";
})(AdUnit || (exports.AdUnit = AdUnit = {}));
const adUnitID = {
    [AdUnit.GameplayStart]: {
        ios: 'ca-app-pub-7842253224043609/4944965952',
        android: 'ca-app-pub-7842253224043609/6689384358'
    },
    [AdUnit.BottomFrame]: {
        ios: 'ca-app-pub-7842253224043609/6449619312',
        android: 'ca-app-pub-7842253224043609/7203006786'
    }
};
class AdManager {
    constructor(gameManager) {
        this.gameManager = gameManager;
        /*
          trackingAuthorizationStatus:
          0 = notDetermined
          1 = restricted
          2 = denied
          3 = authorized
        */
        this.consent$ = new rxjs_1.BehaviorSubject(0);
        this.interstitialStart$ = new rxjs_1.Subject();
        this.interstitialEnd$ = new rxjs_1.Subject();
        this.ads = new Map();
        this.isForeground = true;
        this.holding = null;
        this.curunit = null;
        this.handles = [];
        this.finish = (evt) => {
            this.handles.forEach((h) => h());
            this.handles = [];
            if (this.holding && this.isForeground) {
                this.holding();
                this.holding = null;
                this.interstitialEnd$.next(this.curunit);
                this.curunit = null;
                AdManager.lastAd = Date.now(); // Start counting for next ad
            }
        };
        this.forground = (evt) => {
            this.isForeground = true;
            this.finish(evt);
        };
        this.background = (evt) => {
            this.isForeground = false;
        };
        this.adLoader = (() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            // Once an interstitial ad is shown, it cannot be shown again.
            // Starts loading the next interstitial ad as soon as it is dismissed.
            try {
                yield ((_a = this.ads[AdUnit.GameplayStart]) === null || _a === void 0 ? void 0 : _a.load());
            }
            catch (e) {
                // Something strange with loading
                console.warn(e);
            }
        }));
        this.inited = false;
        this.setup = false;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.inited) {
                return;
            }
            this.inited = true;
            yield new Promise((resolve) => {
                if ((0, Global_1.isDevice)() && this.admob) {
                    setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                        yield this.admob.start();
                        yield this.admob.configure({
                            testDeviceIds: AdManager.testDevices
                        });
                        // Strange there is no direct link in admob library, so we will call it manually
                        // This will always be "2" the first time we call it, so targeted ads from the next time the app loads
                        // if the user allows it
                        if ((0, Global_1.isIOS)()) {
                            const consent = yield (0, admob_plus_cordova_1.execAsync)('requestTrackingAuthorization');
                            this.consent$.next(consent);
                        }
                        console.log('Consented', this.consent$.value);
                        // TODO: Add a bunch more items for GDPR consents and other items via Google Messaging Platform
                        // const consentStatus = await this.consent.getConsentStatus();
                        // console.log('status', consentStatus);
                        // // if (consentStatus === this.consent.ConsentStatus.Required) {
                        //
                        // // }
                        // console.log('infoupdate');
                        //
                        // await this.consent.requestInfoUpdate({
                        //     debugGeography: 1,
                        //     testDeviceIds: this.testDevices
                        // });
                        //
                        // const consentStatus = await this.consent.getConsentStatus();
                        // console.log('status', consentStatus);
                        //
                        // // await this.consent.loadAndShowIfRequired();
                        //
                        // if (await this.consent.canRequestAds()) {
                        //     console.log('can request!');
                        // }
                        return resolve(this.consent$.value);
                    }), AdManager.delay);
                }
                else {
                    return resolve(0);
                }
            });
            yield this.setupAds();
            this.setup = true;
        });
    }
    triggerReward(unit) {
        return __awaiter(this, void 0, void 0, function* () {
            const _poki = (0, Global_1.poki)();
            if (_poki) {
                const p = yield new Promise((resolve, reject) => {
                    // pause your game here if it isn't already
                    _poki.rewardedBreak(() => __awaiter(this, void 0, void 0, function* () {
                        yield AssetManager_1.default.masterSound(false);
                        // you can pause any background music or other audio here
                        this.interstitialStart$.next(unit);
                    })).then((success) => {
                        // if the audio was paused you can resume it here (keep in mind that the function above to pause it might not always get called)
                        return resolve(success);
                    }).catch(reject);
                });
                this.interstitialEnd$.next(unit);
                if (this.gameManager.connected$.value) {
                    yield AssetManager_1.default.masterSound(true);
                }
                return p;
            }
            return false;
        });
    }
    triggerInterstitial(unit) {
        return __awaiter(this, void 0, void 0, function* () {
            let did = false;
            const _poki = (0, Global_1.poki)();
            if (_poki) {
                try {
                    yield _poki.commercialBreak(() => __awaiter(this, void 0, void 0, function* () {
                        // Can pause game music and other actions here while commercial plays
                        yield AssetManager_1.default.masterSound(false);
                        did = true;
                        this.interstitialStart$.next(unit);
                    }));
                    if (did) {
                        this.interstitialEnd$.next(unit);
                    }
                }
                catch (e) {
                    console.error(e);
                    did = false;
                    // Just keep playing if ad blocker used
                }
                if (this.gameManager.connected$.value) {
                    yield AssetManager_1.default.masterSound(true);
                }
            }
            else if (this.setup && this.inited && (0, Global_1.isDevice)()) {
                const now = Date.now();
                if (this.admob && AdManager.lastAd === null) {
                    // Just init
                    this.adLoader().then(); // Don't hold screen
                    AdManager.lastAd = now;
                }
                else if (this.ads[unit] && !this.holding) {
                    if (AdManager.lastAd < (now - config_json_1.default.adinterval)) {
                        if (yield this.ads[unit].isLoaded()) {
                            yield new Promise((resolve) => {
                                did = true;
                                this.holding = resolve;
                                this.curunit = unit;
                                this.handles = [this.ads[unit].on('dismiss', this.finish),
                                    this.ads[unit].on('showfail', this.finish)];
                                this.interstitialStart$.next(this.curunit);
                                return this.ads[unit].show();
                            });
                        }
                        else {
                            // Some reason the ad has not loaded
                            this.adLoader().then();
                        }
                    }
                }
            }
            else if ((0, Global_1.isWeb)()) {
                if (AdManager.lastAd === null) {
                    AdManager.lastAd = Date.now();
                }
                else {
                    did = true;
                    this.interstitialStart$.next(unit);
                    // Maybe could do something here, like actually show an ad??
                    this.interstitialEnd$.next(unit);
                }
            }
            return did;
        });
    }
    makeAdUnit(unit) {
        const info = {
            adUnitId: unit
        };
        if (this.consent$.value != 3) {
            info.npa = '1';
        }
        return info;
    }
    setupAds() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: Move poki init() here, if it works...
            const platform = process.env.PLATFORM;
            if (this.admob && (0, Global_1.isDevice)()) {
                // Gameplay start ad
                const gamestart = new this.admob.InterstitialAd(this.makeAdUnit(adUnitID[AdUnit.GameplayStart][platform]));
                gamestart.on('load', (evt) => {
                    console.log('loaded ad!');
                });
                this.ads[AdUnit.GameplayStart] = gamestart;
                document.addEventListener('admob.ad.dismiss', this.adLoader);
                document.addEventListener('resume', this.forground);
                document.addEventListener('pause', this.background);
            }
        });
    }
    get admob() {
        return window.admob || null;
    }
    destroy() {
        document.removeEventListener('admob.ad.dismiss', this.adLoader);
        document.removeEventListener('resume', this.forground);
        document.removeEventListener('pause', this.background);
    }
}
exports.AdManager = AdManager;
AdManager.lastAd = null;
AdManager.testDevices = [
    "0C04D31E4C64AFE3F74670B05061D0AA",
    "99c3be32e9aa45c30821666a2a5ffb9c"
];
AdManager.delay = 600;
